import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import {
  getAccessToken,
  getModules,
  getUserRoles,
} from '../../state/auth/auth.selectors';

export const authGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const router = inject(Router);
  const store = inject(Store);
  const accessToken = store.selectSignal(getAccessToken)();
  const userRoles = store.selectSignal(getUserRoles)();
  const modules = store.selectSignal(getModules)();

  if (!accessToken) {
    return router.createUrlTree(['/login']);
  }

  if (route.data['modules']) {
    if (
      modules.length > 0 &&
      !modules.some((module: string) => route.data['modules']?.includes(module))
    ) {
      return router.createUrlTree(['/login']);
    }
  }

  if (route.data['roles']) {
    if (!route.data['roles'].some((role: string) => userRoles.includes(role))) {
      return router.createUrlTree(['/login']);
    }
  }

  return true;
};
